import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import {
  fetchUpdateFrequenciesFailure,
  fetchUpdateFrequenciesStart,
  fetchUpdateFrequenciesSuccess,
} from "../../../store/features/customer/updateFrequencies/updateFrequenciesSlice";

const URL = buildApiUrl("/api/v1/instruments/update_frequency/");

const getUpdateFrequenciesApi = async (accessToken) => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchUpdateFrequenciesSaga(action) {
  try {
    const { accessToken } = action.payload;
    const updateFrequenciesData = yield call(
      getUpdateFrequenciesApi,
      accessToken
    );
    yield put(fetchUpdateFrequenciesSuccess(updateFrequenciesData));
  } catch (error) {
    yield put(fetchUpdateFrequenciesFailure(error.message));
  }
}

export default function* updateFrequenciesSaga() {
  yield takeLatest(
    fetchUpdateFrequenciesStart.type,
    fetchUpdateFrequenciesSaga
  );
}
